"use client";

import type { SessionCountdown } from "@/hooks/useSessionCountdown";
import { MC_JOIN_URL } from "@/lib/config";
import { calendarLinks, nextSessionAt } from "@/lib/masterclass";
import { cn } from "@/lib/utils";

// « Bloquez le créneau » — partagé par /mc/ty et /mc/hc.
// Sans replay, tout se joue sur la présence : le créneau doit atterrir dans
// l'agenda dès la confirmation. Les liens ne se calculent qu'une fois l'heure
// client connue (countdown.ready), sinon SSR et client divergent.
export function CalendarLinks({
  countdown,
  className,
}: {
  countdown: SessionCountdown;
  className?: string;
}) {
  if (!countdown.ready) return null;
  const links = calendarLinks(nextSessionAt(), MC_JOIN_URL);

  return (
    <div className={cn(className)}>
      <p className="text-sm font-semibold text-ink">Bloquez le créneau maintenant</p>
      <div className="mt-4 flex flex-col gap-3.5 sm:flex-row sm:justify-center">
        <Link href={links.google}>Google Agenda</Link>
        <Link href={links.outlook}>Outlook</Link>
      </div>
    </div>
  );
}

function Link({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center justify-center rounded-xl border border-ink/15 bg-white px-5 py-3 text-sm font-semibold text-ink transition hover:border-brand/50 hover:bg-cream-dark/50"
    >
      {children}
    </a>
  );
}
